const env = {
  publicUrl: process.env.PUBLIC_URL || '',
  apiUrl: process.env.REACT_APP_API_URL || '',
  locale: {
    force: process.env.REACT_APP_LOCALE_FORCE,
  },
};

export default env;
